/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Firebase from 'firebase/app';

import 'firebase/auth';
import 'firebaseui/dist/firebaseui.css';


Firebase.initializeApp(
{
  apiKey:     "AIzaSyA8sGQhN-9n_dZ7Dcp6sRSCWSQ6op5XYO4",

  projectId:  "fierry-com",
  authDomain: "login.fierry.com",
});
